<template>
    <a-layout-header class="layout-header">
        <div class="logo">
            <img src="@/assets/logoBar.png" style="width:109px;height:40px" />
        </div>
        <a-menu v-model:selectedKeys="selectedKeys" theme="dark" mode="horizontal" class="menu">
            <a-menu-item key="1" v-if="!isSupervisor">
                <template #icon>
                    <HomeOutlined />
                </template>
                <router-link to="/">
                    <b>Inicio</b>
                </router-link>
            </a-menu-item>
            <a-menu-item key="2" v-if="!isSupervisor">
                <template #icon>
                    <user-outlined />
                </template>
                <router-link to="/giros">
                    <b>Giros</b>
                </router-link>
            </a-menu-item>
            <a-menu-item key="3" v-if="!isSupervisor">
                <template #icon>
                    <shopping-outlined />
                </template>
                <router-link to="/caja">
                    <b>Caja</b>
                </router-link>
            </a-menu-item>
            <a-menu-item v-if="isAdmin && !isSupervisor" key="4">
                <template #icon>
                    <SettingOutlined />
                </template>
                <router-link to="/configuraciones">
                    <b>Configuraciones</b>
                </router-link>
            </a-menu-item>
            <a-menu-item v-if="isAdmin && !isSupervisor" key="7">
                <template #icon>
                    <AppstoreOutlined />
                </template>
                <router-link to="/inventario">
                    <b>Inventario</b>
                </router-link>
            </a-menu-item>
            <a-menu-item   key="5">
                <template #icon>
                    <dollar-outlined />
                </template>
                <router-link to="/cierre">
                    <b>Cierre</b>
                </router-link>
            </a-menu-item>
            <a-menu-item key="6" v-if="!isSupervisor">
                <template #icon>
                    <file-excel-outlined />
                </template>
                <router-link to="/reportes">
                    <b>Reportes</b>
                </router-link>
            </a-menu-item>
        </a-menu>
        <a-popover placement="rightBottom" trigger="click" class="avatar-popover">
            <template #content>
                <a-button block type="text" @click="logout">
                    Cerrar Sesión
                    <template #icon>
                        <logout-outlined />
                    </template>
                </a-button>
            </template>
            <template #title>
                <span>{{ username }}</span>
            </template>
            <a-avatar style="background-color: #FEC746">{{ initial }}</a-avatar>
        </a-popover>
    </a-layout-header>
    <router-view />
</template>
  
<script lang="ts" setup>
import {
    HomeOutlined,
    UserOutlined,
    SettingOutlined,
    LogoutOutlined,
    ShoppingOutlined,
    DollarOutlined,
    FileExcelOutlined,
    AppstoreOutlined
} from "@ant-design/icons-vue";

import { ref, computed, watch, onMounted } from "vue";

import router from "@/router";
import { isEmpty } from '@/utils/GeneralsUtils';
import { loginStore } from '@/stores/login';

const store = loginStore();

const menu = {
    "/": "1",
    "/giros": "2",
    "/caja": "3",
    "/configuraciones": "4",
    "/cierre": "5",
    "/reportes": "6",
    "/inventario": "7"
}

onMounted(() => {
    const { path } = router.currentRoute.value
    selectedKeys.value = [menu[path]]
})
const selectedKeys = ref<string[]>(["1"]);

const logout = () => {
    localStorage.removeItem('JWT');
    router.go()
};

const username = computed(() => {
    let result = "";
    let payload = store.tokenPayload;
    if (!isEmpty(payload)) {
        result = payload.name[0].toUpperCase() + payload.name.substring(1)
    }
    return result;
});

const initial = computed(() => {
    let result = "";
    const payload = store.tokenPayload
    if (!isEmpty(payload)) {
        result = payload.name[0].toUpperCase()
    }
    return result;
});

watch(
    () => router.currentRoute.value,
    (to, from) => {
        if (from.fullPath !== to.fullPath) {
            selectedKeys.value = [menu[to.fullPath]]
        }
    }
);

const isAdmin = computed(() => store.tokenPayload.admin);

const isSupervisor = computed(() => {
  return store.tokenPayload.name.toLowerCase() === 'supervisor';
});

</script>
  
<style>
.layout-header {
    display: flex;
    align-items: center;
    background-color: #001529;
    padding: 0 24px;
}

.logo {
    margin-right: 16px;
}

.logo img {
    height: 32px;
}

.menu {
    flex: 1;
}

.avatar-popover {
    position: absolute;
    right: 24px;
}
</style>
  